import { ISimpleUniformShapeWallInfo } from '@/editor/types/wallShape';
import { IPoint2d } from '../math/IPoint2d';
import { IShape2d } from './shape';
import { ArcSeg2d } from '../math/arcSeg2d';

export interface IWallAbsorbUniformStoreOptions {
  roomIds?: string[];
}

export interface IWallAbsorbUniformStore {
  getUniformShapeWallInfos(options?: IWallAbsorbUniformStoreOptions): ISimpleUniformShapeWallInfo[]; // 获取基础的墙体信息
}

export enum ESublineType {
  WallSeg = 'wallSeg',
  // ChordSeg = 'chordSeg',
  WallExtensionLine = 'wallExtensionLine',
  StartNormalLine = 'startNormalLine',
  EndNormalLine = 'endNormalLine',
  HorizontalLine = 'horizontalLine',
  VerticalLine = 'verticalLine',
  Circle = 'circle',
  MidNormalLine = 'midNormalLine'
}

export enum EAbsorbPointType {
  Start = 'start',
  End = 'end',
  Center = 'center',
  Foot = 'foot', // 垂足
  Cross = 'cross', // 交点
  // StartExtension = 'startExtension', // 起点延长线上
  // EndExtension = 'endExtension' // 终点延长线上
  Line = 'line' // 线吸附，不展示吸附点
}

/** 吸附参考线的来源 */
export enum EAbsorbSource {
  /** 方案中的墙体中线及其派生辅助线，吸附到它可与既有墙体连接 */
  Wall = 'wall',
  /** DXF 底图参考线，仅用于对齐，吸附到它不会与墙体连接 */
  FloorPlan = 'floorPlan'
}

export enum EMeasureSubLineType {
  EntityBoxLine = 'entityBoxLine',
  HorizontalLine = 'horizontalLine',
  VerticalLine = 'verticalLine',
  MidNormalLine = 'midNormalLine',
  EntityBoxExtensionLine = 'entityBoxExtensionLine'
}

export interface ISublineInfo {
  wallId: string;
  type: ESublineType;
  absorbPoint: IPoint2d;
  origin?: IPoint2d; // 墙体延长线类型/端点法线类型会添加该参数
  absorbPointType: EAbsorbPointType;
  shape: IShape2d;
  /** 参考线来源；缺省表示编辑器自身生成的辅助线（正交线、弧中垂线等） */
  source?: EAbsorbSource;
  extra?: {
    arcCenterline?: ArcSeg2d;
    skipFallbackAbsorb?: boolean;
  };
}

export interface IAbsorbPointInfo {
  absorbPoint: IPoint2d;
  absorbPointType: EAbsorbPointType;
  sublineInfos: Set<ISublineInfo>;
}
